// Game constants and character definitions
export const CHARACTERS = [
  {
    id: 'mimi',
    name: 'Mimi',
    png: 'https://customer-assets.emergentagent.com/job_mimi-ultra/artifacts/8ht856jw_1000048765.png',
    gif: 'https://customer-assets.emergentagent.com/job_mimi-ultra/artifacts/4a3zjlni_1000048754.gif',
    color: '#ef4444',
  },
  {
    id: 'juma',
    name: 'Juma',
    png: 'https://customer-assets.emergentagent.com/job_mimi-ultra/artifacts/o5u8sh10_1000048763.png',
    gif: 'https://customer-assets.emergentagent.com/job_mimi-ultra/artifacts/pe3n0nij_1000048758.gif',
    color: '#3b82f6',
  },
  {
    id: 'soni',
    name: 'Soni',
    png: 'https://customer-assets.emergentagent.com/job_mimi-ultra/artifacts/5s5xjas2_1000048764.png',
    gif: 'https://customer-assets.emergentagent.com/job_mimi-ultra/artifacts/zi4muymx_1000048762.gif',
    color: '#22c55e',
  },
  {
    id: 'sam',
    name: 'Sam',
    png: 'https://customer-assets.emergentagent.com/job_mimi-ultra/artifacts/yu6o1sd5_1000048766.png',
    gif: 'https://customer-assets.emergentagent.com/job_mimi-ultra/artifacts/0pwihin4_1000048761.gif',
    color: '#eab308',
  },
];

export const LEVELS = ['sky', 'desert', 'jungle', 'london', 'mountain', 'space', 'volcano'];
export const LEVEL_NAMES = ['Sky', 'Desert', 'Jungle', 'London', 'Mountain', 'Space', 'Volcano'];

export const JUMP_FORCE = -7;
export const PLAYER_SIZE = 100;
export const GAME_HEIGHT = 700;
export const GAME_WIDTH = 400;
export const PIPE_WIDTH = 60;
export const COIN_SIZE = 30;

// 200+ real world cities for matchmaking
export const WORLD_CITIES = [
  'Mzuzu, Malawi', 'Kpalim\u00e9, Togo', 'Nkhotakota, Malawi', 'Obuasi, Ghana',
  'Zomba, Malawi', 'Axim, Ghana', 'Karonga, Malawi', 'Chipata, Zambia',
  'Mansa, Zambia', 'Kasama, Zambia', 'Solwezi, Zambia', 'Masvingo, Zimbabwe',
  'Gweru, Zimbabwe', 'Inhambane, Mozambique', 'Xai-Xai, Mozambique', 'Quelimane, Mozambique',
  'Lamu, Kenya', 'Malindi, Kenya', 'Nanyuki, Kenya', 'Isiolo, Kenya',
  'Morogoro, Tanzania', 'Mtwara, Tanzania', 'Lindi, Tanzania', 'Singida, Tanzania',
  'Jinja, Uganda', 'Mbale, Uganda', 'Gulu, Uganda', 'Arua, Uganda',
  'Dori, Burkina Faso', 'Banfora, Burkina Faso', 'Koudougou, Burkina Faso',
  'Kaolack, Senegal', 'Ziguinchor, Senegal', 'Thi\u00e8s, Senegal',
  'Korhogo, Ivory Coast', 'Man, Ivory Coast', 'Daloa, Ivory Coast',
  'Hallstatt, Austria', 'Cesk\u00fd Krumlov, Czech Republic', 'Colmar, France',
  'Ronda, Spain', 'Sintra, Portugal', 'Bruges, Belgium', 'Giethoorn, Netherlands',
  'Bled, Slovenia', 'Kotor, Montenegro', 'Mostar, Bosnia', '\u00d3bidos, Portugal',
  'Gimmelwald, Switzerland', 'Annecy, France', 'Gordes, France', '\u00c8ze, France',
  'Alberobello, Italy', 'Matera, Italy', 'Positano, Italy', 'Varenna, Italy',
  'Burano, Italy', 'Portree, Scotland', 'Tobermory, Scotland', 'Kirkwall, Scotland',
  'Stavanger, Norway', 'Fl\u00e5m, Norway', 'Henningsv\u00e6r, Norway', 'Reine, Norway',
  'Visby, Sweden', 'Sigulda, Latvia', 'C\u0113sis, Latvia', 'Kuld\u012bga, Latvia',
  'Tallinn Old Town, Estonia', 'Haapsalu, Estonia', 'P\u00e4rnu, Estonia',
  'Trogir, Croatia', 'Hvar, Croatia', 'Rovinj, Croatia',
  'Garmisch, Germany', 'Rothenburg, Germany', 'Bamberg, Germany',
  'Piran, Slovenia', 'Gruy\u00e8res, Switzerland', 'M\u00fcrren, Switzerland',
  'Hoi An, Vietnam', 'Sapa, Vietnam', 'Luang Prabang, Laos', 'Pai, Thailand',
  'Ella, Sri Lanka', 'Galle, Sri Lanka', 'Hampi, India', 'Pushkar, India',
  'McLeod Ganj, India', 'Rishikesh, India', 'Pokhara, Nepal', 'Bandipur, Nepal',
  'Shirakawa-go, Japan', 'Takayama, Japan', 'Kamakura, Japan', 'Naoshima, Japan',
  'Jiufen, Taiwan', 'Tainan, Taiwan', 'Bagan, Myanmar', 'Hsipaw, Myanmar',
  'Battambang, Cambodia', 'Kep, Cambodia', 'Vang Vieng, Laos', 'Nong Khiaw, Laos',
  'Ubud, Bali', 'Sidemen, Bali', 'Munduk, Bali', 'Amed, Bali',
  'El Nido, Philippines', 'Siargao, Philippines', 'Sagada, Philippines',
  'Mandalay, Myanmar', 'Kalaw, Myanmar', 'Ninh Binh, Vietnam',
  'Tulum, Mexico', 'San Crist\u00f3bal, Mexico', 'Bacalar, Mexico', 'Sayulita, Mexico',
  'Ba\u00f1os, Ecuador', 'Monta\u00f1ita, Ecuador', 'Otavalo, Ecuador',
  'Huacachina, Peru', 'Ollantaytambo, Peru', 'Pisac, Peru', 'Colca, Peru',
  'Salento, Colombia', 'Jard\u00edn, Colombia', 'Villa de Leyva, Colombia',
  'Bonito, Brazil', 'Paraty, Brazil', 'Jericoacoara, Brazil', 'Len\u00e7\u00f3is, Brazil',
  'Pucon, Chile', 'Valpara\u00edso, Chile', 'San Pedro, Chile',
  'Colonia, Uruguay', 'Cabo Polonio, Uruguay',
  'Trinidad, Cuba', 'Vi\u00f1ales, Cuba', 'Baracoa, Cuba',
  'Livingston, Guatemala', 'Semuc Champey, Guatemala', 'Flores, Guatemala',
  'San Juan del Sur, Nicaragua', 'Le\u00f3n, Nicaragua', 'Ometepe, Nicaragua',
  'Bocas del Toro, Panama', 'Santa Catalina, Panama',
  'Moab, USA', 'Sedona, USA', 'Taos, USA', 'Marfa, USA',
  'Lunenburg, Canada', 'Tofino, Canada', 'Dawson City, Canada',
  'Queenstown, New Zealand', 'Wanaka, New Zealand', 'Kaikoura, New Zealand',
  'Akaroa, New Zealand', 'Raglan, New Zealand', 'Thames, New Zealand',
  'Byron Bay, Australia', 'Broome, Australia', 'Port Douglas, Australia',
  'Esperance, Australia', 'Denmark, Australia', 'Coober Pedy, Australia',
  'Savusavu, Fiji', 'Levuka, Fiji', 'Rarotonga, Cook Islands',
  'Apia, Samoa', 'Neiafu, Tonga', 'Luganville, Vanuatu',
  'G\u00f6reme, Turkey', '\u015eirince, Turkey', 'Safranbolu, Turkey', 'Amasya, Turkey',
  'Musandam, Oman', 'Nizwa, Oman', 'Sur, Oman',
  'Al-Ula, Saudi Arabia', 'Jizan, Saudi Arabia',
  'Khiva, Uzbekistan', 'Bukhara, Uzbekistan', 'Nurata, Uzbekistan',
  'Karakol, Kyrgyzstan', 'Osh, Kyrgyzstan', 'Cholpon-Ata, Kyrgyzstan',
  'Mtskheta, Georgia', 'Mestia, Georgia', 'Sighnaghi, Georgia',
  'Dilijan, Armenia', 'Tatev, Armenia', 'Jermuk, Armenia',
];

export const getRandomCities = (count) => {
  const shuffled = [...WORLD_CITIES].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
};
